import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import WorkflowLayout, { WorkflowIndexRedirect } from "./pages/WorkflowLayout";
import Step1Upload from "./pages/steps/Step1Upload";
import Step2Configure from "./pages/steps/Step2Configure";
import Step3Calculate from "./pages/steps/Step3Calculate";
import Step4Review from "./pages/steps/Step4Review";
import Step5Signoff from "./pages/steps/Step5Signoff";
import Step6Freeze from "./pages/steps/Step6Freeze";
import Login from "./pages/Login";
import ForceChangePassword from "./pages/ForceChangePassword";
import Settings from "./pages/Settings";
import AdminClients from "./pages/AdminClients";
import ClientHistory from "./pages/ClientHistory";
import History from "./pages/History";
import Amendments from "./pages/Amendments";
import CountryReturn from "./pages/CountryReturn";
import RuleCopyCoverage from "./pages/RuleCopyCoverage";
import ExcludedBacklog from "./pages/ExcludedBacklog";
import { AuthProvider } from "./auth/AuthContext";
import { AuthGate } from "./auth/AuthGate";
import { StagingGate } from "./auth/StagingGate";
import { ThemeProvider } from "./theme/ThemeContext";
import { WorkflowProvider } from "./workflow/WorkflowContext";
import { Toaster } from "./components/ui/sonner";
import { ViesStubBanner } from "./components/ViesStubBanner";

function App() {
  return (
    <StagingGate>
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <WorkflowProvider>
        <Toaster richColors closeButton position="top-right" />
        <ViesStubBanner />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/change-password"
            element={<AuthGate><ForceChangePassword /></AuthGate>}
          />
          <Route
            path="/settings"
            element={<AuthGate role="ADMIN"><Settings /></AuthGate>}
          />
          <Route
            path="/admin/clients"
            element={<AuthGate role="ADMIN"><AdminClients /></AuthGate>}
          />
          <Route
            path="/history"
            element={<AuthGate><History /></AuthGate>}
          />
          <Route
            path="/clients/:id/history"
            element={<AuthGate><ClientHistory /></AuthGate>}
          />
          <Route
            path="/amendments"
            element={<AuthGate role="ADMIN"><Amendments /></AuthGate>}
          />
          <Route
            path="/calc/:calcId/country-return/:country"
            element={<AuthGate><CountryReturn /></AuthGate>}
          />
          <Route
            path="/admin/rule-copy-coverage"
            element={<AuthGate role="ADMIN"><RuleCopyCoverage /></AuthGate>}
          />
          <Route
            path="/admin/excluded-backlog"
            element={<AuthGate role="ADMIN"><ExcludedBacklog /></AuthGate>}
          />
          <Route
            path="/"
            element={<AuthGate><Dashboard /></AuthGate>}
          />
          <Route
            path="/workflow"
            element={<AuthGate><WorkflowLayout /></AuthGate>}
          >
            <Route index element={<WorkflowIndexRedirect />} />
            <Route path="upload" element={<Step1Upload />} />
            <Route path="configure" element={<Step2Configure />} />
            <Route path="calculate" element={<Step3Calculate />} />
            <Route path="review" element={<Step4Review />} />
            <Route path="signoff" element={<Step5Signoff />} />
            <Route path="freeze" element={<Step6Freeze />} />
            {/* Unknown workflow slug (typo / stale bookmark) → derived
                active step instead of a blank page. */}
            <Route path="*" element={<WorkflowIndexRedirect />} />
          </Route>
          {/* Top-level catch-all → into the workflow. */}
          <Route path="*" element={<AuthGate><Navigate to="/workflow" replace /></AuthGate>} />
        </Routes>
        </WorkflowProvider>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
    </StagingGate>
  );
}

export default App;
